module.exports = __webpack_public_path__ + "img/color-2.f8efcec.png";